/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteClusterOrgRequest = {
  id: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/**
 * OK
 */
export type DeleteClusterOrgResponseBody = {
  message: string;
};

/** @internal */
export const DeleteClusterOrgRequest$inboundSchema: z.ZodType<
  DeleteClusterOrgRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteClusterOrgRequest$Outbound = {
  id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteClusterOrgRequest$outboundSchema: z.ZodType<
  DeleteClusterOrgRequest$Outbound,
  z.ZodTypeDef,
  DeleteClusterOrgRequest
> = z.object({
  id: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteClusterOrgRequestToJSON(
  deleteClusterOrgRequest: DeleteClusterOrgRequest,
): string {
  return JSON.stringify(
    DeleteClusterOrgRequest$outboundSchema.parse(deleteClusterOrgRequest),
  );
}
export function deleteClusterOrgRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteClusterOrgRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteClusterOrgRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteClusterOrgRequest' from JSON`,
  );
}

/** @internal */
export const DeleteClusterOrgResponseBody$inboundSchema: z.ZodType<
  DeleteClusterOrgResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
});
/** @internal */
export type DeleteClusterOrgResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteClusterOrgResponseBody$outboundSchema: z.ZodType<
  DeleteClusterOrgResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteClusterOrgResponseBody
> = z.object({
  message: z.string(),
});

export function deleteClusterOrgResponseBodyToJSON(
  deleteClusterOrgResponseBody: DeleteClusterOrgResponseBody,
): string {
  return JSON.stringify(
    DeleteClusterOrgResponseBody$outboundSchema.parse(
      deleteClusterOrgResponseBody,
    ),
  );
}
export function deleteClusterOrgResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<DeleteClusterOrgResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteClusterOrgResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteClusterOrgResponseBody' from JSON`,
  );
}
